import React from "react";

const STYLES = {
  active: { bg: "#D1FAE5", text: "#065F46", dot: "#10B981", label: "Active" },
  trial: { bg: "#FEF3C7", text: "#92400E", dot: "#F59E0B", label: "Trial" },
  expired: { bg: "#FEE2E2", text: "#991B1B", dot: "#EF4444", label: "Expired" },
  requires_payment: { bg: "#FEE2E2", text: "#991B1B", dot: "#EF4444", label: "Payment required" },
  suspended: { bg: "#F3F4F6", text: "#374151", dot: "#6B7280", label: "Suspended" },
  cancelled: { bg: "#F3F4F6", text: "#374151", dot: "#6B7280", label: "Cancelled" },
  grace: { bg: "#FEF3C7", text: "#92400E", dot: "#F59E0B", label: "Grace period" },
  revoked: { bg: "#F3F4F6", text: "#6B7280", dot: "#9CA3AF", label: "Revoked" },
  healthy: { bg: "#CCFBF1", text: "#0F766E", dot: "#14B8A6", label: "Healthy" },
  warning: { bg: "#FEF3C7", text: "#92400E", dot: "#F59E0B", label: "Warning" },
  failed: { bg: "#FEE2E2", text: "#991B1B", dot: "#EF4444", label: "Failed" },
  unknown: { bg: "#F3F4F6", text: "#4B5563", dot: "#9CA3AF", label: "Offline" },
  Successful: { bg: "#D1FAE5", text: "#065F46", dot: "#10B981" },
  Pending: { bg: "#FEF3C7", text: "#92400E", dot: "#F59E0B" },
  Failed: { bg: "#FEE2E2", text: "#991B1B", dot: "#EF4444" },
  Reversed: { bg: "#E0E7FF", text: "#3730A3", dot: "#6366F1" },
  "Manually confirmed": { bg: "#CCFBF1", text: "#0F766E", dot: "#14B8A6" },
  Open: { bg: "#DBEAFE", text: "#1E40AF", dot: "#3B82F6" },
  "In Progress": { bg: "#FEF3C7", text: "#92400E", dot: "#F59E0B" },
  Resolved: { bg: "#D1FAE5", text: "#065F46", dot: "#10B981" },
  Closed: { bg: "#F3F4F6", text: "#374151", dot: "#6B7280" },
  Low: { bg: "#F3F4F6", text: "#374151", dot: "#6B7280" },
  Medium: { bg: "#DBEAFE", text: "#1E40AF", dot: "#3B82F6" },
  High: { bg: "#FEF3C7", text: "#92400E", dot: "#F59E0B" },
  Urgent: { bg: "#FEE2E2", text: "#991B1B", dot: "#EF4444" },
  approved: { bg: "#D1FAE5", text: "#065F46", dot: "#10B981", label: "Approved" },
  paid: { bg: "#CCFBF1", text: "#0F766E", dot: "#14B8A6", label: "Paid" },
  pending: { bg: "#FEF3C7", text: "#92400E", dot: "#F59E0B", label: "Pending" },
  recovery_required: { bg: "#FFEDD5", text: "#9A3412", dot: "#F97316", label: "Recovery required" },
  initialized: { bg: "#DBEAFE", text: "#1E40AF", dot: "#3B82F6", label: "Initialized" },
  canceled: { bg: "#F3F4F6", text: "#374151", dot: "#6B7280", label: "Canceled" },
  invited: { bg: "#DBEAFE", text: "#1E40AF", dot: "#3B82F6", label: "Invited" },
  disabled: { bg: "#F3F4F6", text: "#374151", dot: "#6B7280", label: "Disabled" },
  rejected: { bg: "#FEE2E2", text: "#991B1B", dot: "#EF4444", label: "Rejected" },
  New: { bg: "#DBEAFE", text: "#1E40AF", dot: "#3B82F6" },
  Contacted: { bg: "#FEF3C7", text: "#92400E", dot: "#F59E0B" },
  "Demo Done": { bg: "#E9D5FF", text: "#6B21A8", dot: "#A855F7" },
  Interested: { bg: "#CCFBF1", text: "#0F766E", dot: "#14B8A6" },
  Paid: { bg: "#D1FAE5", text: "#065F46", dot: "#10B981" },
  "Not Interested": { bg: "#F3F4F6", text: "#374151", dot: "#6B7280" },
  "Follow Up": { bg: "#FEE2E2", text: "#991B1B", dot: "#EF4444" },
  Sent: { bg: "#D1FAE5", text: "#065F46", dot: "#10B981" },
  Queued: { bg: "#FEF3C7", text: "#92400E", dot: "#F59E0B" },
};

export default function StatusBadge({ status, dot = true, className = "" }) {
  const s = STYLES[status] || STYLES.suspended;
  const label = s.label || status;
  return (
    <span
      data-testid={`status-${String(status).toLowerCase().replace(/\s/g, "-")}`}
      className={`pill ${className}`}
      style={{ background: s.bg, color: s.text }}
    >
      {dot && <span className="w-1.5 h-1.5 rounded-full" style={{ background: s.dot }} />}
      {label}
    </span>
  );
}
